import { Notifications } from "../../../notifications";
export class Cities {
    constructor(form) {
        this.form = form;
    }
    get elements() {
        return this.form.querySelectorAll(".js-city");
    }
    addToFormData(formData) {
        this.elements.forEach((element) => {
            if (element.checked) {
                formData.append(element.name, element.value);
            }
        });
    }
    validate() {
        if (!this.isAnyCityChecked()) {
            Notifications.error(requiredField);
            return false;
        }
        return true;
    }
    isAnyCityChecked() {
        let checkedElements = 0;
        this.elements.forEach((element) => {
            if (element.checked) {
                checkedElements++;
            }
        });
        return checkedElements > 0;
    }
}
